import i18n from '../../i18n';

import React from 'react';
import './WhatsappOptinTnc.css';

const WhatsappOptinTnc = () => {
  const tncUrl =
    'https://www.deere.co.in/assets/pdfs/region-1/finance/india-financing/whatsapp-terms-and-conditions.pdf';
  return (
    <div className="whatsappOptin-TnC">
      <p>
        {i18n.t('BY_CONTINUING_AGREE')}{' '}
        <a href={tncUrl} target="_blank" rel="noopener noreferrer">
          {i18n.t('TERM_AND_CONDITIONS')}.
        </a>
      </p>
    </div>
  );
};

export default WhatsappOptinTnc;
